/**
 * Main file to control the mainmenu
 *
 * @package Wordpress\sww
 * @since 1.0.0
 * @version 1.0.0
 */
 
jQuery( function( $ ) {
	
	if( swwapp.jsdebug == true ) { console.log( 'menu.js loaded' ); }
	
	//built iconMenu with buttons
	swwapp.iconMenu = {
		
		buttons: $( 'span.sww-icon-menu-button' )
		
	};
	
	//the clickHandler
	swwapp.iconMenu.clickHandler = function( e ) {
		
		e.preventDefault();
		
		var parent = $( this ).parents('section'),
			slide = $( parent ).find( 'div.sww-mobile-menu-slide' ),
			value = '';
		
		$( this ).toggleClass( 'open' );
		
		if( $( slide ).hasClass( 'closed' ) ) {
			
			value = '0%';
			
		} else {
			
			value = '-100%';
			
		}
		
		$( slide ).animate( {
			
			'margin-top' : value			
			
		}, 1000, function(){ $( slide ).toggleClass( 'closed' ); } );
		
		return false;
		
	};
	
	//add click handler
	swwapp.iconMenu.addClickHandler = function() { 
		
		for( i = 0; i < swwapp.iconMenu.buttons.length; i++ ) {
			
			$( swwapp.iconMenu.buttons[i] ).on( 'click', swwapp.iconMenu.clickHandler );
			
		}
		
		return true;
		
	}();
	
	//the menuControl and it's buttons
	swwapp.menuControl = {
		
		buttons: $( 'ul.sww-mobile-menu > li' )
		
	};
	
	//the clickHandler
	swwapp.menuControl.clickHandler = function( e ) {
		
		//get the clicked element width
		var clickedElement = $( e.currentTarget ),
			elementWidth = clickedElement[0].clientWidth,
			parent = $( clickedElement ).children(),
			menuElements = $( parent ).children(),
			elementsLength = menuElements.length;
		
		//check where the user has clicked
		if( e.offsetX  > ( elementWidth * 0.9 ) ) {
			
			e.preventDefault();
			
			if( !e.currentTarget.clicked ) {
				
				e.currentTarget.clicked = true;
				
				$( e.currentTarget).addClass( 'open' );
				
				for( i = elementsLength; i >= 0; i-- ) {
					
					$( menuElements[ i ] ).animate({
						
						'line-height': '1.5em',
						'opacity': 1
						
					}, 500 );
					
				}
				
			} else {
				
				e.currentTarget.clicked = false;
				
				$( e.currentTarget).removeClass( 'open' );
				
				for( i = elementsLength; i >= 0; i-- ) {
					
					$( menuElements[ i ] ).animate({
						
						'line-height': '0em',
						'opacity': 0
						
					}, 500 );
					
				}
				
				
				
			}
			
		} 
		
	};
	
	//add clickHandler
	swwapp.menuControl.addClickHandler = function() {
		
		for( i = 0; i < swwapp.menuControl.buttons.length; i++ ) {
			
			$( swwapp.menuControl.buttons[i] ).on( 'click', swwapp.menuControl.clickHandler );
			
		}
		
		return true;
		
	}();
	
	if( swwapp.jsdebug == true ) { 
	
		console.group( 'swwapp Aplication' );
			console.log( swwapp ); 
		console.groupEnd();
	
	}
	
	
} );